import { NotFoundPage } from "@/pages/NotFoundPage/NotFoundPage";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/qrs/$evseId")({
	notFoundComponent: NotFoundPage,
	errorComponent: NotFoundPage,
	component: () => <Outlet />,
});
